import React from 'react';
import { isNumber } from 'lodash';
import Modal from '../../../../../components/Modal';
import InputForm from '../../../../../components/form/InputForm';
import TextAreaForm from '../../../../../components/form/TextAreaForm';
import Anchor from '../../../../../components/link/Anchor';
import InfoTable from '../../../../../components/table/InfoTable';
import CountOfTotal from '../../../../../components/CountOfTotal';
import {
  ORDER_RETURN_ITEM_TYPE,
  ORDER_RETURN_ITEM_TYPE_TEXT,
  PAY_METHOD_TYPE_TEXT,
  RETURN_EXCHANGE_REASON_TYPE,
  MAXIMUM_NUMBER_OF_REFUND_SELLER_AMOUNT_REASON_TEXT,
} from '../../../../../constants/service/app/orderConstants';
import { setDash, setPhoneFormat, setNumberWithComma } from '../../../../../lib/common';
import { formRequiredRules } from '../../../../../lib/formRules';
import './CompleteReturnModal.scss';

const CompleteReturnModal = (props) => {
  const {
    form,
    isOpen,
    data,
    getOrderReturnAttachment,
    extraPrice,
    memo,
    refundSellerAmount,
    closeModal,
    onSubmit,
    setData,
    setRefundSellerAmount,
    validRefundSellerAmount,
  } = props;
  const {
    orderItemId,
    productName,
    productPrice,
    buyerPhone,
    returnType,
    returnReason,
    totalPrice,
    returnDeliveryFee,
    refundExpectAmount,
    sellerDeliveryExtraFee,
    buyerDeliveryExtraFee,
    payMethod,
    bankName,
    bankNumber,
    bankHolder,
    orderReturnId,
    buyerName,
    buyerAccount,
    requestReturnDate,
  } = data;

  /**
   * 반품 사유가 구매자 책임인경우
   * 같은 주문서내에 고객이 최초무료배송비를 지불했는지 체크
   */
  let isPaidReturnDeliveryFee = returnType < ORDER_RETURN_ITEM_TYPE.SERVICE_COMPLAINTS && returnDeliveryFee === 0;

  return (
    <Modal
      title="반품 승인 처리"
      isOpen={isOpen}
      width={660}
      height={600}
      isFooter={true}
      okText="반품 승인 처리"
      onOk={() => onSubmit()}
      onClose={() => closeModal()}
    >
      <div className="complete-return-modal-wrap">
        <div>
          <div>* 1건씩 처리가 가능합니다.</div>
          <div>* 반품 사유 수정 필요 시, 반품 사유 수정을 진행하신 후, 반품처리를 부탁드립니다.</div>
          <p>* 최종 환불 처리는 아몬즈팀에서 확인 후 고객에게 환불을 진행합니다.</p>
        </div>

        <div className="title">반품 정보 확인</div>

        <InfoTable className="selected-order-item-list-table">
          <thead>
            <tr>
              <th>상품 주문번호</th>
              <th>상품명</th>
              <th>상품 가격(정가)</th>
              <th>구매자 연락처</th>
              <th>반품 요청 사유</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="tc">{orderItemId}</td>
              <td className="tc">{productName}</td>
              <td className="tc">{setNumberWithComma(productPrice, '원')}</td>
              <td className="tc">{setPhoneFormat(buyerPhone)}</td>
              <td className="tc">
                <Anchor
                  color="primary"
                  text={ORDER_RETURN_ITEM_TYPE_TEXT[returnType]}
                  isUnderLine={true}
                  onClick={() =>
                    getOrderReturnAttachment({
                      orderReturnId,
                      reasonType: RETURN_EXCHANGE_REASON_TYPE.RETURN_REQUEST,
                      buyerName,
                      buyerAccount,
                      date: requestReturnDate,
                      orderItemId,
                      buyerPhone,
                      productName,
                      reason: returnReason,
                    })
                  }
                />
              </td>
            </tr>
          </tbody>
        </InfoTable>

        <InfoTable className="complete-return-info-table">
          <tbody>
            <tr>
              <td className="tc label">고객 결제 금액</td>
              <td className="tl" colSpan={3}>
                {setNumberWithComma(totalPrice, '원')}
              </td>
            </tr>
            <tr>
              <td className="tc label">최초무료배송비</td>
              <td className="tl" colSpan={3}>
                <span className="emphasize">{setNumberWithComma(returnDeliveryFee, '원')}</span>
                <div className="sub-info">
                  {isPaidReturnDeliveryFee
                    ? `해당 상품은 이미 같은 고객에게 최초무료배송비 3천 원이 청구된 상태이므로, 추가 최초무료배송비 3천 원이 청구되지 않습니다.`
                    : `* (고객 책임 시) 배송비 무료 정책이므로 인한 초기 배송비가 고객에게 청구됩니다.`}
                </div>
              </td>
            </tr>
            <tr>
              <td className="tc label">구매자가 요청한 환불 예상금액</td>
              <td className="tl" colSpan={3}>
                {setNumberWithComma(refundExpectAmount + sellerDeliveryExtraFee, '원')}
                <div className="sub-info">[고객 결제 금액] - [최초무료배송비] + [판매자 부담 추가 배송비]</div>
              </td>
            </tr>
          </tbody>
        </InfoTable>

        <InfoTable className="complete-return-info-table">
          <tbody>
            <tr>
              <td className="tc label">판매자가 책정한 환불 예정금액</td>
              <td className="tl" colSpan={3}>
                <InputForm
                  form={form}
                  type="number"
                  name="refundSellerAmount"
                  rules={[formRequiredRules(true, null, false), { validator: validRefundSellerAmount }]}
                  initialValue={refundSellerAmount}
                  size="large"
                  onChange={(value) => {
                    setRefundSellerAmount(value);
                  }}
                />
                <div className="sub-info">
                  <div>
                    * 판매자가 책정한 환불 예정 금액은 0원부터 [고객 결제 금액] - [최초 무료 배송비] 까지입니다.
                  </div>
                  <div>
                    * 판매자의 환불 예정 금액이 0원 이하이거나 구매자로부터 상품 결제 금액이상의 비용을 청구할 경우,
                    구매자로부터 금액을 직접 받고 환불 예정 금액을 책정합니다.
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td className="tc label">
                <span>판매자 환불 예상금액 책정 사유</span>
                <CountOfTotal content={memo} maxCnt={MAXIMUM_NUMBER_OF_REFUND_SELLER_AMOUNT_REASON_TEXT} />
              </td>
              <td className="tl" colSpan={3}>
                <TextAreaForm
                  form={form}
                  name="memo"
                  placeholder="작성하신 내용은 구매자에게 보여집니다.(아몬즈 앱에 노출)"
                  rules={[formRequiredRules(true, null)]}
                  initialValue={memo}
                  onChange={(value) =>
                    setData({
                      name: 'memo',
                      value,
                    })
                  }
                  maxLength={MAXIMUM_NUMBER_OF_REFUND_SELLER_AMOUNT_REASON_TEXT}
                />
                <div className="sub-info">
                  <div>* 판매자가 책정한 환불 예정 금액에 대한 내용 또는 구매자와 상의한 내용을 적어주세요.</div>
                  <div>* 작성하신 내용은 구매자에게 보여집니다. (아몬즈 앱에 노출)</div>
                </div>
              </td>
            </tr>
          </tbody>
        </InfoTable>

        <InfoTable className="complete-return-info-table">
          <tbody>
            <tr>
              <td className="tc label">추가 청구 비용</td>
              <td className="tl extra-price" colSpan={3}>
                {setNumberWithComma(extraPrice, '원')}
                <div className="sub-info">
                  * 추가 청구 비용은 판매자가 책정한 환불 예정 금액을 변경함에 따라 0원부터 [고객 결제 금액] - [최초
                  무료 배송비] - [판매자 책정한 환불 예정 금액]까지 변경이 됩니다.
                </div>
              </td>
            </tr>
            <tr>
              <td className="tc label">고객 부담 추가 배송비</td>
              <td className="tl" colSpan={3}>
                {setNumberWithComma(buyerDeliveryExtraFee, '원')}
                <div className="sub-info">
                  {isPaidReturnDeliveryFee
                    ? `해당 상품은 이미 같은 고객에게 제주 추가 배송비, 도서산간 배송비가 청구된 상태이므로, 추가 배송비는 청구되지 않습니다.`
                    : `* (고객 책임 시) 제주 추가 배송비, 도서산간 추가 배송비가 고객에게 청구됩니다.`}
                </div>
              </td>
            </tr>
            <tr>
              <td className="tc label">판매자가 정산받을 금액</td>
              <td className="tl" colSpan={3}>
                {setNumberWithComma(
                  totalPrice + buyerDeliveryExtraFee - (isNumber(refundSellerAmount) ? refundSellerAmount : 0),
                  '원',
                )}
                <div className="sub-info">[고객 결제 금액] + [고객 부담 추가 배송비] - [판매자의 환불 예정 금액]</div>
              </td>
            </tr>
          </tbody>
        </InfoTable>

        <InfoTable className="buyer-account-info-table">
          <thead>
            <tr>
              <th>결제 수단</th>
              <th>은행명</th>
              <th>계좌번호</th>
              <th>입금자명</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="tc">{PAY_METHOD_TYPE_TEXT[payMethod]}</td>
              <td className="tc">{setDash(bankName)}</td>
              <td className="tc">{setDash(bankNumber)}</td>
              <td className="tc">{setDash(bankHolder)}</td>
            </tr>
          </tbody>
        </InfoTable>
      </div>
    </Modal>
  );
};

export default CompleteReturnModal;
